export const mapStateLoginToProps = state => {return {login: state.login}};